@if (metadata) {
  <div class="absolute top-0 right-0 p-1">
    <div class="bg-slate-900 text-white rounded px-1">
      <span>{{ duration }}</span>
    </div>
  </div>
}
